



































































import { AlignEnum, SortDirectionEnum } from '../../enums';

import { DataTableColumn, Sort } from '../../models';

import { UiCheckbox, UiRippleInk, UiTooltip } from '../keen-ui';
import TransitionHeight from '../transition-height.component.vue';

export default {
  name: 'data-table-row',
  components: {
    TransitionHeight,
    UiCheckbox,
    UiRippleInk,
    UiTooltip
  },
  computed: {
    rowCellHtmlTag: function (): string {
      return this.isTableHeader ? 'th' : 'td';
    },
    selectable: function (): boolean {
      return (this.selectEnabled || this.multiselectEnabled);
    },
    selectColumnVisible: function (): boolean {
      return (this.selectable && !this.selectionCheckboxesHidden);
    },
    checkboxValue: function (): boolean {
      if (this.isTableHeader) {
        return this.allDataItemsAreSelected;
      }
      return this.isDataItemSelected(this.dataItem);
    },
    areChildrenExpanded: function (): boolean {
      return (this.expandedChildrenIds.some((rowId: string) => rowId === this.dataItem[this.rowsIdField]));
    },
    rowProps: function () {
      return {
        columns: this.columns,
        sort: this.sort,
        selectEnabled: this.selectEnabled,
        multiselectEnabled: this.multiselectEnabled,
        allDataItemsAreSelected: this.allDataItemsAreSelected,
        selection: this.selection,
        hasChildren: this.hasChildren,
        expandedChildrenIds: this.expandedChildrenIds,
        multiChildrenExpandEnabled: this.multiChildrenExpandEnabled,
        selectionCheckboxesHidden: this.selectionCheckboxesHidden,
        rowsIdField: this.rowsIdField
      };
    }
  },
  data: function () {
    return {
      scheduleColumnId: 'schedule',
      updateDateColumnId: 'meta.updateDate',
      userColumnId: 'meta.user',
      enabledColumnId: 'enabled'
    };
  },
  props: {
    columns: Array,
    dataItem: Object,
    isTableHeader: Boolean,
    sort: Object,
    selectEnabled: Boolean,
    multiselectEnabled: Boolean,
    allDataItemsAreSelected: Boolean,
    selection: {
      type: Array,
      default: () => []
    },
    selectionCheckboxesHidden: Boolean,
    hasChildren: Boolean,
    expandedChildrenIds: Array,
    multiChildrenExpandEnabled: Boolean,
    rowsIdField: {
      type: String,
      default: 'id'
    }
  },
  methods: {
    getRowClass: function (dataItem: any) {
      return [
        (!!dataItem ? `epb-data-table-row--level-${ dataItem.level }` : undefined),
        {
          'epb-data-table-row--selectable': (!this.isTableHeader && this.selectable),
          'epb-data-table-row--selected': (!this.isTableHeader && this.selectable && this.isDataItemSelected(dataItem)),
          'epb-data-table-row--head': this.isTableHeader
        }
      ];
    },
    onCheckboxChange: function (selectAll: boolean): void {
      if (!this.isTableHeader) {
        this.onRowClick(this.dataItem);
      } else {
        this.$emit('selectAll', selectAll);
      }
    },
    getCellClass: function (column: DataTableColumn, index: number) {
      const columnSorted = (!!this.sort && (this.sort.field === column.id));
      return {
        'epb-data-table-row__cell--root': (index === 0 && (!!this.dataItem && this.dataItem.level === 0)),
        'epb-data-table-row__cell--sortable': (this.isTableHeader && column.sortable),
        'epb-data-table-row__cell--sorted-asc': (this.isTableHeader &&
          (columnSorted && (this.sort.direction === SortDirectionEnum.ASCENDING))),
        'epb-data-table-row__cell--sorted-desc': (this.isTableHeader &&
          (columnSorted && (this.sort.direction === SortDirectionEnum.DESCENDING))),
        'epb-data-table-row__cell--align-center': ((column.align === AlignEnum.CENTER) || (column.id === this.enabledColumnId)),
        'epb-data-table-row__cell--align-end': (column.align === AlignEnum.END)
      };
    },
    getCellStyle: function (column: DataTableColumn, index: number) {
      const width = (column.width || ({
        [this.updateDateColumnId]: '9rem',
        [this.userColumnId]: '8rem',
        [this.enabledColumnId]: '8rem'
      }[column.id]) || '100%');
      const cellStyles: any = {
        flexBasis: width,
        flexShrink: (!width.includes('%') ? 0 : undefined)
      };
      return cellStyles;
    },
    getCellContentPadding: function (columnIndex: number): string {
      if ((!!this.dataItem && this.dataItem.level !== 0) && columnIndex === 0) {
        return `${ 25 * this.dataItem.level + 5 }px`;
      }
    },
    onHeaderClick: function (column: DataTableColumn): void {
      if (column.sortable) {
        let sort: Sort = {
          field: column.id,
          direction: SortDirectionEnum.ASCENDING
        };
        if (!!this.sort && (this.sort.field === column.id)) {
          if (this.sort.direction === SortDirectionEnum.ASCENDING) {
            sort.direction = SortDirectionEnum.DESCENDING;
          } else {
            sort = {};
          }
        }
        this.$emit('sortChange', sort);
      }
    },
    onRowClick: function (dataItem: any): void {
      if (this.selectable) {
        const indexOfDataItem = this.selection.findIndex(
          (selectedItem: any) => (selectedItem[this.rowsIdField] === dataItem[this.rowsIdField]));
        let selection = this.selection.slice();
        if (indexOfDataItem >= 0) {
          selection.splice(indexOfDataItem, 1);
        } else {
          if (this.multiselectEnabled) {
            selection.push(dataItem);
          } else {
            selection = [dataItem];
          }
        }
        this.$emit('selectionChange', selection);
      }
    },
    onCellClick: function (column: DataTableColumn): void {
      if (this.isTableHeader) {
        this.onHeaderClick(column);
      } else {
        this.onRowClick(this.dataItem);
      }
    },
    onRowExpand: function (dataItem): void {
      const expandedChildrenIds = (!this.multiChildrenExpandEnabled && dataItem.level === 0) ? [] : [...this.expandedChildrenIds];
      if (this.expandedChildrenIds.includes(dataItem[this.rowsIdField])) {
        [dataItem[this.rowsIdField], ...this.getChildrenIds(dataItem)].forEach((id: string) => {
          if (expandedChildrenIds.includes(id)) {
            expandedChildrenIds.splice(expandedChildrenIds.indexOf(id), 1);
          }
        });
      } else {
        expandedChildrenIds.push(dataItem[this.rowsIdField]);
      }
      this.$emit('expandedChildrenChange', expandedChildrenIds);
    },
    getScheduleCellHtml: function (dataItem: any) {
      const scheduleTextItems: string[] = [];
      const scheduleMessages = this.$epb.messages.crud.schedule;

      if (!!dataItem.schedule.activationDate) {
        const activationDateString = this.$epb.utils.compileMessage(scheduleMessages.from, {
          date: this.getDateString(dataItem.schedule.activationDate)
        });
        scheduleTextItems.push(activationDateString);
      }
      if (!!dataItem.schedule.deactivationDate) {
        const deactivationDateString = this.$epb.utils.compileMessage(scheduleMessages.to, {
          date: this.getDateString(dataItem.schedule.deactivationDate)
        });
        scheduleTextItems.push(deactivationDateString);
      }
      if (!scheduleTextItems.length) {
        return scheduleMessages.always;
      }
      return scheduleTextItems.join('<br>');
    },
    getDateString: function (date: Date, includeTime = false): string {
      const options: any = {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      };
      if (includeTime) {
        options.hour = '2-digit';
        options.minute = '2-digit';
        options.hourCycle = 'h23';
      }
      return date.toLocaleString(this.$epb.locale, options);
    },
    getCellText: function (dataItem: any, column: DataTableColumn): string {
      const columnIdHierarchy = column.id.split('.');
      let data = dataItem;
      columnIdHierarchy.forEach((columnIdNode: string) => {
        if (columnIdNode in data) {
          data = data[columnIdNode];
        } else {
          data = undefined;
        }
      });
      if (Array.isArray(data)) {
        return data.join(', ');
      }
      if (data instanceof Date) {
        return this.getDateString(data, true);
      }
      return data;
    },
    getChildrenIds: function (dataItem): string[] {
      if (!dataItem.children) {
        return [];
      }
      const ids = [];
      dataItem.children.forEach((child: any) => {
        ids.push(child.id);
        this.getChildrenIds(child).forEach((id: string) => {
          ids.push(id);
        });
      });
      return ids;
    },
    isDataItemSelected: function (dataItem: any): boolean {
      return this.selection.some((selectedItem: any) => (selectedItem[this.rowsIdField] === dataItem[this.rowsIdField]));
    }
  }
};
